import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../utils/axios";

export const getProjectNameChangesApplications = createAsyncThunk(
  "jppnProjectNameChangesSlice/getProjectNameChangesApplications",
  async (props) => {
    try {
      const { source, params } = props;

      const response = await axios.get(`jppn/project-name-changes`, {
        params,
        cancelToken: source.token,
      });

      const data = await response.data;

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const getProjectNameChangesApplication = createAsyncThunk(
  "jppnProjectNameChangesSlice/getProjectNameChangesApplication",
  async (params) => {
    try {
      const { id, source } = params;
      const response = await axios.get(`jppn/project-name-changes/${id}`, {
        cancelToken: source.token,
      });

      const data = await response.data;

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const createProjectNameChangesApplication = createAsyncThunk(
  "jppnProjectNameChangesSlice/createProjectNameChangesApplication",
  async (values) => {
    try {
      const response = await axios.post(`jppn/project-name-changes`, values);

      const data = await response.data;

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const updateProjectNameChangesApplication = createAsyncThunk(
  "jppnProjectNameChangesSlice/updateProjectNameChangesApplication",
  async (values) => {
    try {
      const { id } = values;
      const response = await axios.put(
        `jppn/project-name-changes/${id}`,
        values,
      );

      const data = await response.data;

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const deleteEditNameApplication = createAsyncThunk(
  "jppnProjectNameChangesSlice/deleteEditNameApplication",
  async (id) => {
    try {
      const response = await axios.delete(
        `jppn/project-name-changes/delete/${id}`,
      );

      const data = await response.data;

      return id;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);

export const approveEditNameApplication = createAsyncThunk(
  "jppnProjectNameChangesSlice/approveEditNameApplication",
  async (id) => {
    try {
      const response = await axios.put(
        `jppn/project-name-changes/approve/${id}`,
      );

      const data = await response.data;

      return data;
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        console.error(error);
      }
    }
  },
);
